import { IconDate } from '@components/icons/date';
import { RelativeSpinner } from '@components/loading-spinner';
import { Sidebar } from '@components/sidebar';
import { useScopedTranslate } from '@locale/translate';

import { useJourneyAction, useUpdateJourneyAction } from 'api/journey-actions/hooks';
import { TimeSavedContainer } from 'ui/helpers';
import {
  ActionFooter,
  ActionHeader,
  createActionForm,
  SidebarProps,
  useCreateActionFormStore,
} from 'ui/journey-builder/node-types/common';

import { ActionType, CalendarEventData, CalendarEventFormFields, formatFormData } from './common';

import { FormWithUnsavedChangesPrompt } from '../../journey-builder/unsaved-changes-prompt';

const Form = createActionForm<CalendarEventData>();

export const SidebarContent = (props: SidebarProps) => {
  const { journeyActionId } = props;
  const { t } = useScopedTranslate(sidebarLocale);
  const formStore = useCreateActionFormStore();
  const isDirty = formStore.useIsDirty();

  const { data, isLoading } = useJourneyAction<ActionType>(journeyActionId);

  const editMutation = useUpdateJourneyAction(journeyActionId);
  const handleSave = (data: CalendarEventData) => {
    return editMutation.mutateAsync(formatFormData(data));
  };

  if (isLoading || !data) {
    return <RelativeSpinner />;
  }
  return (
    <Sidebar>
      <ActionHeader title={t('calendarEvent')} icon={IconDate} iconColor="green100" {...props} />
      <Sidebar.Content>
        <FormWithUnsavedChangesPrompt store={formStore} onSubmit={handleSave}>
          <CalendarEventFormFields Form={Form} data={data} />
          <Sidebar.Separator />
          <TimeSavedContainer {...data.timeSaved} />
          <ActionFooter action={data} isDisabled={!isDirty || editMutation.isLoading} form={Form} />
        </FormWithUnsavedChangesPrompt>
      </Sidebar.Content>
    </Sidebar>
  );
};

const sidebarLocale = {
  en: {
    calendarEvent: 'Calendar event',
  },
};
